<template>
    <haze-full v-if="fullversion" @toggle-version="toggleVersion" />
    <haze-short v-else @toggle-version="toggleVersion" />
</template>

<script>
import HazeShort from './HazeWidget.vue'
import HazeFull from './HazeWidgetFullVersion.vue'

export default {
  components: {
    HazeShort,
    HazeFull
  },
  data () {
    return {
      fullversion: false
    }
  },
  methods: {
    toggleVersion () {
      this.fullversion = !this.fullversion
      this.$analytics.track('toggle version', this.fullversion ? 'full' : 'short')
    }
  }
}

</script>
